module.exports = __webpack_public_path__ + "img/footer-background.b7df74d0.jpg";